import { clip, midi } from 'scribbletune';
import CueOptions from '../Data/CueOptions';

const produceMidi = (song) => {
  console.log(song)
    const bar = (time) => 
      clip({
          notes: 'B2',
          pattern: '-'.repeat(time * 4)
      })

    const section = (part) => 
     clip({
        notes: part + ' D2 D#2 E2',
        pattern: 'xxxx'
      })
    
    const end = clip({
        notes: 'E4 D2 D#2 E2',
        pattern: 'xxxx'
      })

    const song_midi = song.map(el => {
      let part_midi = 'C1'
      try {
        part_midi = CueOptions.find(cue_el => el.part === cue_el.part).midi
      } catch (error) {
        console.log(error)
      }
      

      return [].concat(section(part_midi)).concat(bar(el.length - 1))
    })
          
      return midi([].concat(...song_midi, end), 'chords.mid');
}

export default produceMidi